@let splitCurrencyAmount = config().splitCurrencyAmount;
<div class="stepper-container" data-cy="stepper" data-variant="variant6">
  <div
    class="stepper-keys"
    [style.color]="config().body.progressbar.labelColor"
    [style.fontFamily]="config().body.progressbar.labelFontFamily"
  >
    <p class="earn">
      {{ config().body.progressbar.earnLabel }}
    </p>

    <p class="collect-in-points">
      {{ config().body.progressbar.collectLabel }}
    </p>

    <p class="spend">
      {{ config().body.progressbar.spendLabel }}
    </p>
  </div>

  <div class="progress-bar-container">
    <div
      class="progress-bar"
      [style.backgroundColor]="config().body.progressbar.containerColor"
    ></div>
    <div
      data-cy="progress-bar"
      class="progress-bar-value"
      [style.width]="challenge() | progressWidth: limitsPerNbSteps"
      [style.backgroundColor]="config().body.progressbar.progressColor"
    ></div>
  </div>

  <ul
    class="steps steps-container"
    [style.left]="
      challenge().targets.length === 1
        ? '160px'
        : challenge().targets.length === 2
          ? '40px'
          : '8px'
    "
  >
    @for (item of challenge().targets; track i; let i = $index) {
      @let stepStatus = challenge() | stepStatus: i;
      <li
        class="stepper-item"
        [style.marginRight]="
          challenge().targets.length === 2 && i === 0 ? '40px' : 0
        "
      >
        <div
          class="reward-container"
          [class.reached]="stepStatus !== StepStatus.UNREACHED"
        >
          @let bgColors = config().body.rewards.backgroundColors;
          <div
            b2cSvg
            class="step-bubble"
            [style.width]="config().body.rewards.backgroundColors.bubbleWidth"
            [style.minHeight]="
              config().body.rewards.backgroundColors.bubbleHeight
            "
            [alt]="
              config().body.rewards.backgroundColors.alternativeText[stepStatus]
                | replaceVars: challenge().steps[i].reward
            "
            [svgPath]="config().body.rewards.backgroundColors.backgroundImage"
            [width]="config().body.rewards.backgroundColors.bubbleWidth"
            [fill]="bgColors[stepStatus].fill"
            [stroke]="bgColors[stepStatus].stroke"
          ></div>
          <div class="step-bubble-content">
            @if (
              stepStatus === StepStatus.DEFAULT ||
              (stepStatus === StepStatus.REACHED &&
                config().body.rewards.showReachedIconInBubble)
            ) {
              <img
                class="step-reached-icon"
                [src]="config().body.progressbar.pictureStageReached.imageUrl"
                [alt]="
                  config().body.progressbar.pictureStageReached.alternativeText
                "
                [style.width]="
                  config().body.progressbar.pictureStageReached.width
                "
              />
            } @else {
              @if (splitCurrencyAmount) {
                @let amountParts =
                  challenge().steps[i].reward | formatAmountParts;
                <span
                  class="step-reward split-amount"
                  [style.fontFamily]="config().body.rewards.rewardFontFamily"
                  [style.color]="bgColors[stepStatus].rewardColor"
                >
                  <span class="amount-currency">{{
                    amountParts.currency
                  }}</span>
                  <span class="amount-integer">{{ amountParts.integer }}</span>
                  <span class="amount-fraction">{{
                    amountParts.fraction
                  }}</span>
                </span>
              } @else {
                <span
                  class="step-reward"
                  [style.fontFamily]="config().body.rewards.rewardFontFamily"
                  [style.color]="bgColors[stepStatus].rewardColor"
                  [innerHTML]="
                    challenge().steps[i].reward | formatReward | safe
                  "
                ></span>
              }
            }
          </div>

          <div class="step-progressbar">
            <div
              class="step-circle"
              data-cy="step_reached"
              [class.reached]="
                stepStatus === StepStatus.REACHED ||
                stepStatus === StepStatus.DEFAULT
              "
              [style.borderColor]="
                stepStatus === StepStatus.UNREACHED
                  ? '#d1d4d3'
                  : 'var(--challenge-primary-color)'
              "
            >
              @if (
                stepStatus === StepStatus.DEFAULT ||
                (stepStatus === StepStatus.REACHED &&
                  config().body.rewards.showReachedIconInBubble)
              ) {
                <img
                  [alt]="
                    config().body.progressbar.pictureStageReached
                      .alternativeText
                  "
                  class="step-circle-icon"
                  [src]="config().body.progressbar.pictureStageReached.imageUrl"
                />
              }
            </div>
          </div>
        </div>

        <div
          class="step-target"
          data-cy="target_reached"
          [style.color]="
            stepStatus === StepStatus.UNREACHED
              ? config().body.targets.color
              : '#bbbbbb'
          "
          [style.fontFamily]="config().body.targets.fontFamily"
        >
          {{ item | formatAmount: 'currency' : 0 }}
        </div>
      </li>
    }
  </ul>
</div>
